import React, { useContext } from "react"
import { getLocalStorageValue, setLocalStorageValue } from "../utils/localStorageUtil"

const HEBREW_LOCAL = { key: "he", textAlign: "right", dir: "rtl" }
const ENGLISH_LOCAL = { key: "en", textAlign: "left", dir: "ltr" }
const DEFAULT_LOCAL = ENGLISH_LOCAL;

const LocalContext = React.createContext({ local: DEFAULT_LOCAL });

export const useLocalContext = () => useContext(LocalContext);

class LocalProvider extends React.Component {

  state = {
    local: DEFAULT_LOCAL,
  };

  onLocalChange = (value,setLocalStorage=true) => {
    // const value = e.currentTarget.value;
    //console.log("Set local to " + value);
    let newLocal
    switch (value) {
      case "he":
        newLocal = HEBREW_LOCAL
        break
      default:
        newLocal = ENGLISH_LOCAL
        break
    }
    //setLocal(newLocal)
    if(setLocalStorage){
      setLocalStorageValue("local", JSON.stringify(newLocal));
    }
    this.setState({ local: newLocal, onLocalChange: this.onLocalChange });
  }

  componentDidMount() {
    //console.log("Local Provider did Mount");
    // Getting local from local Storage!
    const local = JSON.parse(getLocalStorageValue("local"));
    if (local) {
      //console.log("Storage Local:", local);
      this.setState({ local, onLocalChange: this.onLocalChange })
    }
  }

  render() {
    //console.log("Local Provider Render");
    const { children } = this.props;
    const localData = this.state;
    const local = localData.local;
    //console.log("Local:", local);
    return (
      <LocalContext.Provider value={{ local: local, onLocalChange: this.onLocalChange }}>
        {children}
      </LocalContext.Provider>
    )
  }
}

export default LocalProvider;
